module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "filter-main-container"
  }, [_c('i', {
    staticClass: "material-icons clear_icon pointer",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('div', {
    staticClass: "div-1"
  }, [_vm._v("Currently showing")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-header white--text",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.isAnyTagSelected) ? _c('div', [_vm._v("All spots")]) : _c('div', {
    staticClass: "selected-tag-onload"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedTagName.name) + "\n            "), _c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1em",
      "margin-bottom": "-0.1em"
    },
    on: {
      "click": function($event) {
        return _vm.SelectTag(_vm.selectedTagName.type, _vm.selectedTagName.name, _vm.selectedTagName.index)
      }
    }
  }, [_vm._v("cancel")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "margin-top": "0.2em"
    }
  }, [_c('div', {
    staticClass: "t-1"
  }, [_vm._v("in")]), _vm._v(" "), _c('div', {
    staticClass: "t-2"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.search_loc.query_location),
      expression: "$store.state.search_loc.query_location"
    }],
    staticClass: "search-location-dropdown pointer",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.search_loc, "query_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.query_location,
        _vm.goToRoute(_vm.$store.state.search_loc.query_location)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Barcelona")]), _vm._v(" "), _c('option', [_vm._v("Berlin")]), _vm._v(" "), _c('option', [_vm._v("Copenhagen (København)")]), _vm._v(" "), _c('option', [_vm._v("Florence (Firenze)")]), _vm._v(" "), _c('option', [_vm._v("Lisbon (Lisboa)")]), _vm._v(" "), _c('option', [_vm._v("London")]), _vm._v(" "), _c('option', [_vm._v("Los Angeles")]), _vm._v(" "), _c('option', [_vm._v("Madrid")]), _vm._v(" "), _c('option', [_vm._v("Milan (Milano)")]), _vm._v(" "), _c('option', [_vm._v("New York")]), _vm._v(" "), _c('option', [_vm._v("Paris")]), _vm._v(" "), _c('option', [_vm._v("Porto")]), _vm._v(" "), _c('option', [_vm._v("Rome (Roma)")]), _vm._v(" "), _c('option', [_vm._v("San Francisco")])])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll-contain",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.tags), function(tag, tagName) {
    return _c('div', {
      key: tagName,
      staticClass: "text-xs-left pointer"
    }, [(tagName === 'spotType') ? _c('div', [_c('div', {
      staticClass: "pl-3 tagline"
    }, [_vm._v(_vm._s(tag.tagLine))]), _vm._v(" "), _c('div', {
      staticClass: "tagTypes"
    }, _vm._l((tag.tagArr), function(tagselect, tagIndex) {
      return _c('div', {
        key: tagIndex
      }, [_c('div', {
        staticClass: "tag-container",
        style: (("background-image: url(" + (_vm.filterImage(tagselect.photoId)) + "); height:" + (tag.height === 'small'? '6.429em': '11.429em'))),
        attrs: {
          "id": ("tag-id-" + tagName + "-" + tagIndex)
        },
        on: {
          "click": function($event) {
            return _vm.SelectTag(tagName, tagselect.tag, tagIndex)
          }
        }
      }, [_c('div', {
        staticClass: "tagName",
        attrs: {
          "id": ("tag-id-" + tagName + "-" + tagIndex + "-name")
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_vm._v("\n                  " + _vm._s(tagselect.tag) + "\n                  "), (tagselect.pic_cnt > 0) ? _c('span', [_vm._v("(" + _vm._s(tagselect.pic_cnt) + ")")]) : _vm._e()]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (tag.selectedTags.includes(tagselect.tag)),
          expression: "tag.selectedTags.includes(tagselect.tag)"
        }],
        staticClass: "material-icons"
      }, [_vm._v("check_circle")])])])])
    }), 0)]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filter-footer-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("\n      Results are sorted by\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFilterSort),
      expression: "selectedFilterSort"
    }],
    staticClass: "sort-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFilterSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ts"
    }
  }, [_vm._v("Upload Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lks"
    }
  }, [_vm._v("Likes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "km"
    }
  }, [_vm._v("Distance")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "random"
    }
  }, [_vm._v("Random")])])]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-header-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("Select a filter to limit results")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47689422","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter.vue
// module id = 840
// module chunks = 11